"use client";
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    MessageCircleBlankSolid: function() {
        return MessageCircleBlankSolid;
    },
    default: function() {
        return _default;
    }
});
const _jsxruntime = require("react/jsx-runtime");
const _utils = require("@mui/material/utils");
const MessageCircleBlankSolid = (0, _utils.createSvgIcon)(/*#__PURE__*/ (0, _jsxruntime.jsx)("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/ (0, _jsxruntime.jsx)("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M1.00002 12C1.00002 5.92487 5.92488 1 12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23C10.3273 23 8.73941 22.626 7.31765 21.9563L2.19613 22.9806C1.86827 23.0462 1.52933 22.9435 1.29291 22.7071C1.05649 22.4707 0.953864 22.1317 1.01944 21.8039L2.04374 16.6824C1.37404 15.2606 1.00002 13.6727 1.00002 12Z",
        fill: "currentColor"
    })
}), "MessageCircleBlankSolid");
const _default = MessageCircleBlankSolid;
